export const normalizeEditField = ({
  formData,
  setFormData,
  fieldName,
  valueKey,
  labelKey,
}) => {
  if (
    Array.isArray(formData[fieldName]) &&
    formData[fieldName].length > 0 &&
    typeof formData[fieldName][0] === "object" &&
    !formData[fieldName][0].value 
  ) {
    const mapped = formData[fieldName].map((item) => ({
      value: item[valueKey],
      label: item[labelKey],
    }));

    setFormData((prev) => ({
      ...prev,
      [fieldName]: mapped,
    }));
  }
};

export const normalizePlatformField = ({ formData, setFormData }) => {
  const { platforms } = formData;
  if (!platforms || !Array.isArray(platforms)) return;
  const platformMap = {};

  if (typeof platforms[0] === "object") {
    platforms.forEach((p) => {
      if (p?.id) platformMap[p.id] = true;
    });
  }
  else {
    platforms.forEach((id) => {
      if (id) platformMap[id] = true;
    });
  }
  setFormData((prev) => ({
    ...prev,
    platforms: platformMap,
  }));
};


export const normalizeContentRequirements = ({ formData, setSections }) => {
  if (Array.isArray(formData.content_requirements)) {
    const mappedSections = formData.content_requirements.map((item) => ({
      id: item.id,
      format: { label: item.format },
      quantities: item.quantities,
    }));
    setSections(mappedSections);
  }
};

export const normalizeTargetingFields = ({ formData, setFormData, setSections }) => {
  normalizeEditField({ formData, setFormData, fieldName: "audience_type", valueKey: "id", labelKey: "type" });
  normalizeEditField({ formData, setFormData, fieldName: "influencer_tier", valueKey: "id", labelKey: "influencer_type" });
  normalizeEditField({ formData, setFormData, fieldName: "cities", valueKey: "id", labelKey: "city_name" });
  normalizeEditField({ formData, setFormData, fieldName: "offer_type", valueKey: "id", labelKey: "TypeName" });

  normalizePlatformField({ formData, setFormData });
  normalizeContentRequirements({ formData, setSections});
};
